import React, { createContext } from 'react';
import { hoursMinFromTime } from '../../../contexts/BookingUtilities';
import axios from "../../../utils/axios";
import { cWarn } from '../CustomLogger';
import { serializeAddress } from './BookTaxiUtilities';

export const TaxiBookingContext = createContext();

class TaxiBookingContextProvider extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            focusKey:'from',
            fpsAvailable:[],
            checkingFpAvailable:false,
            processingBooking:false,
            bookingComplete:false,
            successTaxiId:0,
            focusIndex:0,
            bookingData:{
                passengers:[
                    {
                        valid:false,
                        data:{}
                    }
                ],
                pickupTime:{
                    isSubmitted:true,
                    valid:true,
                    data:{
                        asapOrAdvance:'1'
                    }
                },
                from:{
                    valid:false,
                    data:{}
                },
                vias:[],
                to:{
                    valid:false,
                    data:{}
                },
                provider:{
                    isSubmitted:true,
                    valid:true,
                    data:{
                        agnosticOrSelect:'1'
                    }
                },
                shareTaxi:true,
                description:''

            },
            isLoading: true,
        };

    }   

    setFocus(key,index=0){
        this.setState({
            focusKey:key,
            focusIndex:index
        })
    }

    removeViaAtIndex = (indexToRemove) => {
        this.setState((prevState) => {
          const { bookingData } = prevState;
          const updatedArr = [...bookingData.vias];
          updatedArr.splice(indexToRemove, 1); // Remove 1 item at the specified index
          const updatedBookingData = { ...bookingData, vias: updatedArr };
          return { bookingData: updatedBookingData };
        });
      };
    
    removePassengerAtIndex = (indexToRemove) => {
        this.setState((prevState) => {
          const { bookingData } = prevState;
          const updatedArr = [...bookingData.passengers];
          updatedArr.splice(indexToRemove, 1); // Remove 1 item at the specified index
          const updatedBookingData = { ...bookingData, passengers: updatedArr };
          return { bookingData: updatedBookingData };
        });
      };

      isReadyToSelectFp = () => {
        
        const {
            passengers=[],
            pickupTime:{
                isSubmitted:pickupTimeValid
            },
            from:{
                isSubmitted:fromValid
            },
            to:{
                isSubmitted:toValid
            },
            vias=[]
        } = this.state.bookingData;

        for(let i=0; i<passengers.length; i+=1){
            const {isSubmitted=false} = passengers[i];
            if(!isSubmitted){
                return false;
            }
        }
        if(!pickupTimeValid){
            return false;
        }
        if(!fromValid){
            return false;
        }
        if(!toValid){
            return false;
        }
        for(let i=0; i<vias.length; i+=1){
            const {isSubmitted=false} = vias[i];
            if(!isSubmitted){
                return false;
            }
        }

        return true;
    }

    parseLocationToBookingObjectPoint = (locationData) => {
        const output = {};
        const {
            knownOrNew='1',
            knownAddress = {}
        } = locationData;
        if(knownOrNew === '1'){
            const {
                type='',
                value:LocationId=''
            } = knownAddress;
            output.type = type;
            output.address = {
                id:LocationId,
                name:serializeAddress(locationData)
            }; 

        }
        else{
            output.type = 'otherDomesticAddress';

            const grabKeys = [
                'houseNumber',
                'houseName',
                'street',
                'town',
                'postcode',
                'country'
            ];
            output.additionalAddress = {};
            output.addressId = 0;
            for(let i=0; i<grabKeys.length; i+=1){
                output.additionalAddress[grabKeys[i]] = locationData[grabKeys[i]];
            }
            output.friendlyAddress = serializeAddress(locationData);
            output.useExistingAddress = false;
        }
        return output;
    }

    parseTimeFromPickupTime = (data) => {
        
        let orderTime = {};
        const {
            asapOrAdvance='1',
            travelTime={},
            travelDate={}
        } = data;
        if(asapOrAdvance === '1'){
            orderTime = new Date();
            orderTime.setMinutes(orderTime.getMinutes() + 5);
        }
        else if(asapOrAdvance === '2'){
            orderTime = travelTime;
        }
        else{
            orderTime = new Date(
                travelDate.getFullYear(),
                travelDate.getMonth(),
                travelDate.getDate(),
                travelTime.getHours(),
                travelTime.getMinutes()
            );
        }
        const hoursMins = hoursMinFromTime(orderTime);
        return {
            date:orderTime,
            'year':orderTime.getFullYear(),
            'month':orderTime.getMonth()+1,
            'day':orderTime.getDate(),
            'hours':hoursMins.hours,
            'mins':hoursMins.mins

        } 
    }



    buildBookingDataObject = () => {
        const {
            bookingData:{
                from:{
                    data:originData
                },
                to:{
                    data:destinationData
                },
                vias,
                pickupTime:{
                    data:pickupTimeData
                },
                passengers=[],
                provider,
                shareTaxi='1',
                description=''
            }
        } = this.state;
        const parsedOriginData = this.parseLocationToBookingObjectPoint(originData);
        const parsedDestinationData = this.parseLocationToBookingObjectPoint(destinationData);

        const {
            date,
            year,
            month,
            day,
            hours,
            mins
        } = this.parseTimeFromPickupTime(pickupTimeData);

        const viasProcessed = [];
        for(let i=0; i<vias.length; i+=1){
            const parsedViaData  = this.parseLocationToBookingObjectPoint(vias[i].data);
            viasProcessed.push(parsedViaData);
        }

        const {
            data:{
                agnosticOrSelect:isProviderAgnostic='1',
                provider:selectedFp='0'
            }
        } = provider;

        let fp = false;
        if(isProviderAgnostic !== '1'){
            fp = selectedFp;
        }

        const isShared = shareTaxi ? '1' : '0';

        return {
            date,
            origin:{
                destination:parsedOriginData
            },
            destination:{
                destination:parsedDestinationData,
            },
            legs:[
                {
                    destination:parsedDestinationData,
                    mode:'bookMeATaxi',
                    finalStop:true,
                    transportData:{
                        expectedCapacity:passengers.length,
                        fp,
                        gtmOversight:'0',
                        hasShareCode:'0',
                        hoursMin:{
                            hours,
                            mins
                        },
                        luggage:'0',
                        meetGreetOption:'0',
                        privateShare:'0',
                        privateShareSplitFee:'1',
                        selfBook:'0',
                        selfBookCompanyName:'',
                        seldBookCompanyPhone:'',
                        seldBookDriverMobile:'',
                        seldBookDriverName:'',
                        shareCode:'',
                        shareTaxi:isShared,
                        description,
                        travelTime:date
                    }, 
                    vias:viasProcessed
                }
            ],
            direction:'outgoing',
            directionId:2,
            holidayTag:'none',
            otherDateIntegers:{
                day,
                month,
                year
            },
        };
    }

    confirmBooking = () => {

        
        this.setState({
            processingBooking:true
        })
        const {
            bookingData:{
                passengers
            }
        } = this.state;
        const outputBookingData = this.buildBookingDataObject();

        
        const doIt = true;
        if(doIt){
            const payload = {
                bookingData:outputBookingData,
                preAuthorize:true,
                passengers,
                staffAdminBooking:true
            };

            const apiPath = `${process.env.REACT_APP_API_URL}/storebooking`;
            axios.post(apiPath,payload,{
                timeout: 30000,
                withCredentials:true
            }).then(res =>{

                const {
                    data:{
                        taxiIds
                    }
                } = res;
                if(taxiIds.length > 0){
                    this.setState({
                        processingBooking:false,
                        successTaxiId:taxiIds[0]
                    });
                }
                else{
                    this.setState({
                        processingBooking:false,
                    })
                }
                

            }).catch(err => {
                // console.log('caught the error');
                this.setState({
                    processingBooking:false,
                })
                cWarn(err);
            });
        }
        else{
            this.setState({
                processingBooking:false
            })
        }
    }

    checkTaxiAvailability = () => {
        const formReady = this.isReadyToSelectFp();
        if(formReady){

            this.setState({
                fpAvailable:false,
                checkingFpAvailable:true
            })

            const outputBookingData = this.buildBookingDataObject();

            const testData = {
                legIndex:0,
                bookingData:outputBookingData
            };
            
            const apiPath = `${process.env.REACT_APP_API_URL}/traveloptions`;
            axios.post(apiPath,testData,{
                timeout: 30000,
                withCredentials:true
            }).then(res =>{

                const {
                    data:{
                        canDoTaxi=[]
                    }
                } = res;

                this.setState({
                    checkingFpAvailable:false,
                    fpsAvailable:canDoTaxi
                });

            }).catch(err => {
                // console.log('caught the error');
                this.setState({
                    checkingFpAvailable:false
                })
                cWarn(err);
            });
            
        }
    }

    render() {
        return (
            <TaxiBookingContext.Provider value={{
                ...this.state,
                setState:this.setState.bind(this),
                setFocus:this.setFocus.bind(this),
                removeViaAtIndex:this.removeViaAtIndex.bind(this),
                removePassengerAtIndex:this.removePassengerAtIndex.bind(this),
                isReadyToSelectFp:this.isReadyToSelectFp.bind(this),
                checkTaxiAvailability:this.checkTaxiAvailability.bind(this),
                confirmBooking:this.confirmBooking.bind(this)
            }}>
                {this.props.children}
            </TaxiBookingContext.Provider>
        );
    }
}

export default TaxiBookingContextProvider;